var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.91667C14.1667 2.68655 13.9801 2.50001 13.75 2.50001H11.6667C9.48276 2.39122 7.62106 4.06675 7.5 6.25001V8.50001H5.41667C5.18655 8.50001 5 8.68655 5 8.91667V11.0833C5 11.3135 5.18655 11.5 5.41667 11.5H7.5V17.0833C7.5 17.3135 7.68655 17.5 7.91667 17.5H10.4167C10.6468 17.5 10.8333 17.3135 10.8333 17.0833V11.5H13.0167C13.2073 11.5027 13.3755 11.3758 13.425 11.1917L14.025 9.02501C14.0586 8.90023 14.0324 8.76693 13.9541 8.66415C13.8758 8.56136 13.7542 8.50073 13.625 8.50001H10.8333V6.25001C10.8763 5.82259 11.2371 5.49785 11.6667 5.50001H13.75C13.9801 5.50001 14.1667 5.31346 14.1667 5.08334V2.91667Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbicon);
export default __webpack_public_path__ + "static/media/fbicon.ec304a3187fa02f8c468deeefba4bdd3.svg";
export { ForwardRef as ReactComponent };